import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Button, ButtonBorderRadius } from "components/general/Button/Button";
import { Text } from "components/general/Text";
import { MOBILE_WIDTH, TABLET_WIDTH, useIsMobile } from "hooks/useDeviceType";
import bebop1800ImgSrc from "../../../img/home/1800-bebop-sticker.png";
import deftOrDieImgSrc from "../../../img/home/deft-or-die-sticker.png";
import hugsNotRugsImgSrc from "../../../img/home/hugs-not-rugs-sticker.png";
import tradeRageImgSrc from "../../../img/home/trade-rage-sticker.png";
import voteBullRunImgSrc from "../../../img/home/vote-bull-run-sticker.png";
import whaleImgSrc from "../../../img/home/whale-sticker.png";
import { Title } from "./element/Title";
import { NAV_LINKS } from "config/consts";

export const FeatureClaimAchievements = () => {
  const isMobile = useIsMobile();
  return (
    <Container>
      <Title
        css={css`
          margin-bottom: 48px;
          @media (max-width: ${TABLET_WIDTH}px) {
            margin-bottom: 24px;
          }
        `}
      >
        Mark those trading milestones with NFT achievements.
        <br />
        Celebrate your journey.
      </Title>

      <Button
        navigateTo={NAV_LINKS.BADGES}
        target="_blank"
        rel="noreferrer nofollow"
        buttonType="secondary"
        buttonCss={css`
          z-index: 1;
          padding: 22px;
          border-radius: ${ButtonBorderRadius.Mid};

          @media (max-width: ${MOBILE_WIDTH}px) {
            padding: 11px 14px;
            font-size: 12px !important;
          }
        `}
      >
        <Text
          textStyle="Title"
          size="Large"
          textCss={css`
            @media (max-width: ${MOBILE_WIDTH}px) {
              font-size: 12px;
            }
          `}
        >
          Claim yours now
        </Text>
      </Button>

      {/* Stickers */}
      <img
        src={whaleImgSrc}
        alt="Whale sticker"
        style={{
          position: "absolute",
          top: isMobile ? 30 : 40,
          left: 0,
          width: isMobile ? 108 : 365,
        }}
      />
      <img
        src={deftOrDieImgSrc}
        alt="Deft or die sticker"
        style={{
          position: "absolute",
          top: isMobile ? 22 : 24,
          left: isMobile ? 66 : 220,
          width: isMobile ? 102 : 346,
        }}
      />
      <img
        src={bebop1800ImgSrc}
        alt="Bebop rare swapper sticker"
        style={{
          position: "absolute",
          right: 0,
          top: isMobile ? 64 : 120,
          width: isMobile ? 110 : 385,
        }}
      />
      <img
        src={voteBullRunImgSrc}
        alt="Vote bull run sticker"
        style={{
          position: "absolute",
          left: 0,
          bottom: isMobile ? 0 : 40,
          width: isMobile ? 108 : 346,
        }}
      />
      <img
        src={hugsNotRugsImgSrc}
        alt="Hugs not rugs sticker"
        style={{
          position: "absolute",
          right: 30,
          bottom: isMobile ? 10 : 64,
          width: isMobile ? 66 : 222,
        }}
      />
      <img
        src={tradeRageImgSrc}
        alt="Trade rage sticker"
        style={{
          position: "absolute",
          right: isMobile ? 50 : 120,
          bottom: isMobile ? 0 : 64,
          width: isMobile ? 158 : 385,
        }}
      />
    </Container>
  );
};

// Sub-components

const Container = styled.section(() => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "339px 100px 200px",
  width: "100%",

  [`@media (max-width: ${MOBILE_WIDTH}px)`]: {
    padding: "127px 40px 97px",
  },
}));
